import { render, staticRenderFns } from "./TakeAwayMenuCategoryProduct.vue?vue&type=template&id=2acfdb02&"
import script from "./TakeAwayMenuCategoryProduct.vue?vue&type=script&lang=ts&"
export * from "./TakeAwayMenuCategoryProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports